import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import css from './styles.module.scss';

interface Props {
  value: number;
  text?: string;
  variant: 'top' | 'bottom';
  classNames?: string;
}

const ArenaOfferTimer: React.FC<Props> = ({
  value,
  text,
  variant,
  classNames,
}) => {
  const { t } = useTranslation();
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  // const seconds = value % 60;

  return (
    <span className={cn(css.arenaOfferTimer, css[variant], classNames)}>
      {text
        ? t(text)
        : `${String(hours).padStart(2, '0')}h : ${String(minutes).padStart(2, '0')}m`}
    </span>
  );
};

export default ArenaOfferTimer;
